/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BiomarkerResponseDto
 */
export interface BiomarkerResponseDto {
    /**
     * Unique identifier of the biomarker
     * @type {string}
     * @memberof BiomarkerResponseDto
     */
    id: string;
    /**
     * Patient ID
     * @type {string}
     * @memberof BiomarkerResponseDto
     */
    patientId: string;
    /**
     * Date of the biomarker measurement
     * @type {Date}
     * @memberof BiomarkerResponseDto
     */
    date: Date;
    /**
     * Name of the biomarker
     * @type {string}
     * @memberof BiomarkerResponseDto
     */
    name: string;
    /**
     * Value of the biomarker
     * @type {string}
     * @memberof BiomarkerResponseDto
     */
    value: string;
    /**
     * Reference range for the biomarker
     * @type {string}
     * @memberof BiomarkerResponseDto
     */
    referenceRange: string;
    /**
     * Unit of measurement
     * @type {string}
     * @memberof BiomarkerResponseDto
     */
    unit?: string;
    /**
     * Whether the value is out of range
     * @type {boolean}
     * @memberof BiomarkerResponseDto
     */
    outOfRange: boolean;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof BiomarkerResponseDto
     */
    createdAt: Date;
    /**
     * Last update timestamp
     * @type {Date}
     * @memberof BiomarkerResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the BiomarkerResponseDto interface.
 */
export function instanceOfBiomarkerResponseDto(value: object): value is BiomarkerResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('referenceRange' in value) || value['referenceRange'] === undefined) return false;
    if (!('outOfRange' in value) || value['outOfRange'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function BiomarkerResponseDtoFromJSON(json: any): BiomarkerResponseDto {
    return BiomarkerResponseDtoFromJSONTyped(json, false);
}

export function BiomarkerResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BiomarkerResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patientId': json['patientId'],
        'date': (new Date(json['date'])),
        'name': json['name'],
        'value': json['value'],
        'referenceRange': json['referenceRange'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'outOfRange': json['outOfRange'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function BiomarkerResponseDtoToJSON(json: any): BiomarkerResponseDto {
    return BiomarkerResponseDtoToJSONTyped(json, false);
}

export function BiomarkerResponseDtoToJSONTyped(value?: BiomarkerResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'date': ((value['date']).toISOString()),
        'name': value['name'],
        'value': value['value'],
        'referenceRange': value['referenceRange'],
        'unit': value['unit'],
        'outOfRange': value['outOfRange'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

